import React from "react";
import Footer from "../../Components/Footer/Footer";

const Helpers = () => {
  const videoData = [
    {
      title: "How to Register & Login",
      description:
        "Step-by-step guide to create a new account & login securely to your account.",
      videoUrl:
        "https://blr1.digitaloceanspaces.com/vmb-2.0-dev-bucket/media/photologue/photos/Vmb%20signup%20video_2025-08-21T10-19-43-496Z.mp4",
    },
    {
      title: "How to Fill all the required Fields",
      description: "Learn how to fill your details on vmb.",
      videoUrl:
        "https://blr1.digitaloceanspaces.com/vmb-2.0-dev-bucket/media/photologue/photos/Vmb%20basic_info%20module_2025-08-21T10-20-59-566Z.mp4",
    },
    {
      title: "how to send and accept requests ",
      description: "Send and manage interest requests.",
      videoUrl:
        "https://blr1.digitaloceanspaces.com/vmb-2.0-dev-bucket/media/photologue/photos/Vmb%20proposal%20module_2025-08-21T10-22-13-801Z.mp4"
    },
    {
      title: "How to Update Profile",
      description: "Instructions on updating personal details.",
      videoUrl:
        "https://blr1.digitaloceanspaces.com/vmb-2.0-dev-bucket/media/photologue/photos/Vmb%20update%20module_2025-08-21T10-23-39-387Z.mp4",
    },

    {
      title: "How to Accept Requests & View Profiles",
      description:
        "Understand how to accept incoming interest requests and view the full details of other user profiles.",
      videoUrl:
        "https://blr1.digitaloceanspaces.com/vmb-2.0-dev-bucket/media/photologue/photos/Vmb%20questionary%20module_2025-08-21T10-24-30-988Z.mp4",
    },

    {
      title:
        "How to Send Questionnaire Request & View Mutually Accepted Profiles",
      description:
        "Learn how to send a questionnaire to another devotee as part of the match-making process.",
      videoUrl:
        "https://blr1.digitaloceanspaces.com/vmb-2.0-dev-bucket/media/photologue/photos/Vmb%20mutually%20module_2025-08-21T10-25-21-873Z.mp4",
    },

  ];

  return (
    <div className="font-jost flex min-h-screen flex-col bg-gradient-to-b from-gray-100 to-white pt-10">
      <div className="mb-10 text-center">
        <h1 className="text-primary pt-10 text-2xl font-semibold sm:text-3xl lg:text-4xl">
          Learn How to Use the VMB
        </h1>
        <p className="mt-2 text-gray-600">Watch these videos to get started</p>
        <div className="mx-auto mt-2 w-32 border-b-2 border-yellow-400"></div>
      </div>

      <div className="mx-auto grid max-w-6x2 grid-cols-1 gap-8 pb-10 sm:grid-cols-2">
        {videoData.map((video, index) => (
          <div
            key={index}
            className="rounded-xl bg-white p-4 shadow-md transition-all hover:shadow-xl"
          >
            <video
              controls
              className="mb-3 h-80 w-full rounded-md border border-gray-300 object-cover"
            >
              <source src={video.videoUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <h2 className="mb-1 text-lg font-bold text-gray-800">
              {video.title}
            </h2>
            <p className="text-sm text-gray-600">{video.description}</p>
          </div>
        ))}
      </div>

      <Footer />
    </div>
  );
};

export default Helpers;
